import { render } from "./LoadingSpinners.vue?vue&type=template&id=111fd8b0&scoped=true"
import script from "./LoadingSpinners.vue?vue&type=script&lang=js"
export * from "./LoadingSpinners.vue?vue&type=script&lang=js"

import "./LoadingSpinners.vue?vue&type=style&index=0&id=111fd8b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111fd8b0"]])

export default __exports__